import { Flag } from '../../utils';

export const getMatchingFlags = (value: number, flags: Flag[] = []): Flag[] => {
  if (value === 0) {
    const zero = flags.find((f) => f.id === 0);
    return zero ? [zero] : [];
  }
  return flags.filter(({ id }) => id !== 0 && (value & id) === id);
};
